import {
  Briefcase,
  CurrencyInr,
  HourglassHigh,
  IdentificationBadge,
  User,
  Warning,
} from "@phosphor-icons/react"
import { Modal } from "@vesatogo/grass-core"
import { inr } from "@vesatogo/utils"
import Deviation from "~/assets/deviation.svg"
import { getOrdinalString } from "~/utils/ordinalString"

type DeviationModalConfirmationProps = {
  isOpen: boolean
  setOpen: any
  onConfirm?: () => void
  onCancel?: () => void
  data?: {
    tradeId?: any
    buyerName?: string
    availableAmount?: number
    tradeAmount?: number
    deviationCount?: number
    exceedingAmount?: number
  }
}
export const DeviationModalConfirmation = ({
  isOpen,
  setOpen,
  onConfirm,
  onCancel,
  data,
}: DeviationModalConfirmationProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      title={"Deviation Confirmation"}
      primaryActionButtonProps={{
        text: "Continue with Deviation",
        onClick: async () => {
          onConfirm?.()
        },
      }}
      secondaryActionButtonProps={{
        text: "Close without saving",
        intent: "danger",
        onClick: () => {
          onCancel?.()
        },
      }}
    >
      <div>
        <img
          alt="biz logo"
          width={250}
          height={250}
          src={Deviation}
          className="m-auto pb-5"
        />
        <div className="border-1 border-gray-300 mt-5 rounded-lg">
          <div className="text-green font-600 bg-gray-100 rounded-lg p-2  flex gap-2 items-center">
            <Warning className="text-yellow" size={20} weight="fill" />
            Credit Limit Exceeded (
            {getOrdinalString(data?.deviationCount || 0) + " "}
            deviation)
          </div>
          <div className="p-2 text-gray-800 flex flex-col gap-2">
            <div className="flex gap-1 items-center">
              <User className="text-green-400" size={20} weight="fill" /> Buyer
              Name: {data?.buyerName}
            </div>
            <div className="flex gap-1 items-center">
              <CurrencyInr className="text-green-300" size={20} weight="fill" />
              Available Limit: {inr(data?.availableAmount || 0)}
            </div>
            <div className="flex gap-1 items-center">
              <Briefcase className="text-brown" size={20} weight="fill" />
              Current Transaction Amount: {inr(data?.tradeAmount || 0)}
            </div>
            <div className="flex gap-1 items-center">
              <HourglassHigh className="text-cyan" size={20} weight="fill" />
              Exceeding by: {inr(data?.exceedingAmount || 0)}
            </div>
          </div>
        </div>
        <div className="my-3 font-600">
          Do you want to continue with deviation or cancel this trade?
        </div>
      </div>
    </Modal>
  )
}
